module.exports = __webpack_public_path__ + "static/img/floor2-txt.2a4cdb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor2-txt.png
// module id = +WdU
// module chunks = 1